import { LOADING_STATES } from "../../../../features/loading";
import { IFlyerFilterOptions, IFlyerState } from "./flyer-state.interface";

export function createFlyerState(): IFlyerState {
  return {
    errors: null,
    filterOptions: defaultFilterOptions(),
    filters: null,
    isCreateModalOpen: false,
    isGridView: true,
    loading: LOADING_STATES.default,
    permissions: null,
    searchResults: null,
  };
}

export function defaultFilterOptions(): IFlyerFilterOptions {
  return {
    owners: [],
  };
}
